var React = require('react');

function ArrowAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"arrow-alt"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"_ÎÓÈ_1","data-name":"—ÎÓÈ_1"},React.createElement("path",{"className":"cls-1","d":"M64.25,314.25H280.64L204.7,390.19a64.25,64.25,0,0,0-18.82,45.43h0c0,57.24,69.2,85.9,109.68,45.43L481.18,295.43a64.25,64.25,0,0,0,0-90.86L295.56,18.95C255.09-21.53,185.88,7.14,185.88,64.38h0a64.25,64.25,0,0,0,18.82,45.43l75.94,75.94H64.25A64.25,64.25,0,0,0,0,250H0A64.25,64.25,0,0,0,64.25,314.25Z"})))]);
}

ArrowAlt.defaultProps = {"viewBox":"0 0 500 500"};

module.exports = ArrowAlt;

ArrowAlt.default = ArrowAlt;
